import { Grid, Typography, Box } from "@mui/material";
import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
function DashboardCard(data) {
  const getHashOfString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      // tslint:disable-next-line: no-bitwise
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return hash;
  };

  const normalizeHash = (hash, min, max) => {
    return Math.floor((hash % (max - min)) + min);
  };
  const [range, setRange] = React.useState(10);
  const [saturation, setSaturation] = React.useState(50);
  const [lightness, setLightness] = React.useState(50);

  const generateHSL = (name, saturationRange, lightnessRange) => {
    const hash = getHashOfString(name);
    const h = normalizeHash(hash, 0, 360);
    const s = normalizeHash(hash, saturationRange[0], saturationRange[1]);
    const l = normalizeHash(hash, lightnessRange[0], lightnessRange[1]);
    return [h, s, l];
  };

  const HSLtoString = (hsl) => {
    return [
      `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%, 20%)`,
      `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`,
    ];
  };

  const generateColorHsl = (id, saturationRange, lightnessRange) => {
    return HSLtoString(generateHSL(id, saturationRange, lightnessRange));
  };

  const getInitials = (name) => {
    // debugger;
    console.log(Array.from(name)[0]);
    return Array.from(name)[0];
  };

  const setValue1 = (functionFor) => {
    return (e) => {
      const value = parseInt(e.target.value);
      functionFor(value);
    };
  };

  const getRange = (value, range) => {
    return [Math.max(0, value - range), Math.min(value + range, 100)];
  };

  const saturationRange = getRange(saturation, range);
  const lightnessRange = getRange(lightness, range);

  //
  const color = generateColorHsl(data.title, saturationRange, lightnessRange);
  const navigate = useNavigate();
  const handleRedirect = (id) => {
    console.log(id);
    // If "Unassigned", ignore the specific status id and show all statuses (id=0)
    let finalId = data.title === "Unassigned" ? 0 : id;
    let url = `/agent/list?id=${finalId}`;
    if (data.deptId > 0) {
      url += `&deptId=${data.deptId}`;
    }

    // Special agentId logic for Dashboard cards
    let finalAgentId = data.agentId;
    if (data.title === "Unassigned") {
      finalAgentId = -1; // Flag for Unassigned (agent_id IS NULL)
    } else if (["Open", "Pending by User", "Pending by IT Admin", "User On Hold", "Admin On Hold", "Pending by Vendor"].includes(data.title)) {
      // If no specific agent is selected in dashboard, show all assigned tickets for this status
      if (finalAgentId === 0) {
        finalAgentId = -2; // Flag for Assigned (agent_id IS NOT NULL)
      }
    }

    if (finalAgentId !== 0) {
      url += `&agentId=${finalAgentId}`;
    }

    // Default fromDate to 2026-01-01 only for specific status cards (NOT Total or Closed)
    let finalFromDate = data.fromDate;
    if (!finalFromDate && !["Total Tickets", "Closed"].includes(data.title)) {
      finalFromDate = "2026-01-01";
    }

    if (finalFromDate) {
      url += `&fromDate=${finalFromDate}`;
    }

    if (data.toDate) {
      url += `&toDate=${data.toDate}`;
    }
    if (data.title === "Admin On Hold") {
      url += `&isAdmin=1`;
    } else if (data.title === "User On Hold") {
      url += `&isAdmin=0`;
    }

    navigate(url);
  };

  return (
    <Grid
      className={`dashboard-card`}
      onClick={() => handleRedirect(data.id)}
      sx={{
        backgroundColor: color[0],
        color: color[1],
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        height: '150px',
        borderRadius: '25px 5px 25px 5px',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.02)'
        }
      }}
    >
      <Box sx={{ 
        width: '100%',
        minHeight: '45px', 
        display: 'flex', 
        alignItems: 'flex-start', 
        justifyContent: 'center',
      }}>
        <Typography 
          sx={{ 
            fontWeight: 700, 
            lineHeight: 1.2,
            fontSize: '1rem',
            textAlign: 'center'
          }}
        >
          {data.title}
        </Typography>
      </Box>
      <Typography variant="h2" sx={{ fontWeight: 600, mb: 1 }}>
        {data.count}
      </Typography>
    </Grid>
  );
}

export default memo(DashboardCard);
